import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getBreadcrumbs } from "../helper/apicalls/course";

export const fetchBreadcrumbs = createAsyncThunk(
  "breadcrumbs/fetch",
  async (payload, { rejectWithValue }) => {
    try {
      let courseKey = payload;
      if (typeof payload === "string" && payload.includes("/")) {
        const parts = payload.split("/").filter(Boolean);
        if (
          (parts[0] === "courses" ||
            parts[0] === "materials" ||
            parts[0] === "question-bank") &&
          parts.length > 1
        ) {
          courseKey = parts[1];
        } else if (parts.length > 0) {
          courseKey = parts[0];
        }
      }

      const response = await getBreadcrumbs(courseKey);
      const data =
        Array.isArray(response) && response.length > 0 ? response[0] : response;
      return { courseKey, data };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const breadcrumbsSlice = createSlice({
  name: "breadcrumbs",
  initialState: {
    data: null,
    currentCourseKey: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearBreadcrumbs: (state) => {
      state.data = null;
      state.currentCourseKey = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBreadcrumbs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBreadcrumbs.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.currentCourseKey = action.payload.courseKey;
      })
      .addCase(fetchBreadcrumbs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearBreadcrumbs } = breadcrumbsSlice.actions;
export default breadcrumbsSlice.reducer;
